/**
 * Created by Jerker Nord on 2018-11-27.
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {StickyWild} from "../../symbols/StickyWild";
import {ThorReelSymbol} from "../../symbols/ThorReelSymbol";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";

export class ThorRandomWildsView extends BaseView {

    private static WILD_LIGHTNING_OFFSET_XPOS:number = 0;//151;
    private static WILD_LIGHTNING_OFFSET_YPOS:number = 0;//-243;
    private static RANDOM_WILD_SPINE_ASSET_NAME:string = "lightningRandom";
    private static CHAIN_WILD_SPINE_ASSET_NAME:string = "chainCD";
    private static RANDOM_WILD_ANIMATION_NAME:string = "Random";
    private static WILD_CHAIN_ANIMATION_NAME:string = "WildChainCD";
    private static BONUS_LIGTNING_SOUNDS:string[] = [ThorSoundConfig.instance.BONUS_LIGHTNING_01, ThorSoundConfig.instance.BONUS_LIGHTNING_02];

    private _currentBonusLightningSound:number = 0;
    private _layer:ScalableLayer;
    private _overlayWilds:StickyWild[];
    private _allOverlayWilds:StickyWild[];
    private _wildLightningAnimation:PIXI.spine.Spine;
    private _wildChainAnimation:PIXI.spine.Spine;
    private _addNewWildsTL:TimelineLite;
    private _newWildsAdded:boolean = false;
    private _removeTL = new TimelineLite();

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._overlayWilds = [];
        this._allOverlayWilds = [];
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.WILD_OVERLAY.name);
    }

    protected initAnimations():void {
        this._layer.addChild(this);

        this._wildLightningAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorRandomWildsView.RANDOM_WILD_SPINE_ASSET_NAME));
        this._wildLightningAnimation.alpha = 0;
        this.addChild(this._wildLightningAnimation);

        this._wildChainAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorRandomWildsView.CHAIN_WILD_SPINE_ASSET_NAME));
        this._wildChainAnimation.alpha = 0;
        this.addChild(this._wildChainAnimation);
    }

    public abort(newWilds:boolean[][]):void {
        if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
            this._addNewWildsTL.pause();
            this._addNewWildsTL.kill();
        }

        if(this._newWildsAdded == false) {
            for(let i:number = 0; i < newWilds.length; i++) {
                for(let j:number = 0; j < newWilds[i].length; j++) {
                    if(newWilds[i][j]) {
                        const originalSymbol:StateReelSymbol = Reels.getSymbol(i, j)!;
                        const stickyWild:StickyWild = new StickyWild(originalSymbol.symName, new PIXI.Point(i, j));
                        stickyWild.position.x = Helper.getSymbolPositions(i, j)[0];
                        stickyWild.position.y = Helper.getSymbolPositions(i, j)[1];
                        this._allOverlayWilds.push(stickyWild);
                        stickyWild.alpha = 0;
                        this.addChildAt(stickyWild, 0);
                    }
                }
            }

            this.shuffleWilds(this._allOverlayWilds);
        }

        for(let k:number = 0; k < this._allOverlayWilds.length; k++) {
            this._allOverlayWilds[k].alpha = 1;
        }
        this._overlayWilds = [];
        this._newWildsAdded = false;
        this._wildChainAnimation.alpha = 0;
        this._wildLightningAnimation.alpha = 0;
    }

    private createLightningToStickyWildTL(position:[number, number]):TimelineLite {
        const lightningToStickyWildTL:TimelineLite = new TimelineLite();
        lightningToStickyWildTL.add(() => this._wildLightningAnimation.position.x = position[0] + ThorRandomWildsView.WILD_LIGHTNING_OFFSET_XPOS);
        lightningToStickyWildTL.add(() => this._wildLightningAnimation.position.y = position[1] + ThorRandomWildsView.WILD_LIGHTNING_OFFSET_YPOS);
        lightningToStickyWildTL.add(() => this._wildChainAnimation.position.x = position[0]);
        lightningToStickyWildTL.add(() => this._wildChainAnimation.position.y = position[1]);
        lightningToStickyWildTL.add(() => this._wildLightningAnimation.alpha = 1);
        lightningToStickyWildTL.add([
            () => this.playBonusLightningSound(),
            new SpineTween(this._wildLightningAnimation, 0, ThorRandomWildsView.RANDOM_WILD_ANIMATION_NAME, 0)
        ]);
        lightningToStickyWildTL.add(() => this._wildLightningAnimation.alpha = 0);
        lightningToStickyWildTL.add(() => this._wildChainAnimation.alpha = 1);
        lightningToStickyWildTL.add([
            () => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_CHAINS),
            new SpineTween(this._wildChainAnimation, 0, ThorRandomWildsView.WILD_CHAIN_ANIMATION_NAME, 0), "-=0.2"
        ]);
        lightningToStickyWildTL.add(() => this._wildChainAnimation.alpha = 0);

        return lightningToStickyWildTL;
    }

    private playBonusLightningSound():void {
        if(this._currentBonusLightningSound == 0) {
            this._currentBonusLightningSound++;
        } else {
            this._currentBonusLightningSound--;
        }
        SlotGame.sound.playEffect(ThorRandomWildsView.BONUS_LIGTNING_SOUNDS[this._currentBonusLightningSound]);
    }

    private getBonusSymbolPosition():PIXI.Point {
        let tempSymbol:ThorReelSymbol;
        let symbolPosition:[number, number];

        for(let i:number = 0; i < 4; i++) {
            tempSymbol = <ThorReelSymbol>Reels.getSymbol(4, i)!;
            if(tempSymbol.symName == "B") {
                symbolPosition = Helper.getSymbolPositions(4, i);
                break;
            }
        }

        return new PIXI.Point(symbolPosition![0], symbolPosition![1]);
    }

    public getAddNewWildsTL(newWilds:boolean[][]):TimelineLite {
        this._newWildsAdded = true;
        if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
            this._addNewWildsTL.pause();
            this._addNewWildsTL.kill();
        }
        this._addNewWildsTL = new TimelineLite();

        for(let i:number = 0; i < newWilds.length; i++) {
            for(let j:number = 0; j < newWilds[i].length; j++) {
                if(newWilds[i][j]) {
                    const originalSymbol:StateReelSymbol = Reels.getSymbol(i, j)!;
                    const stickyWild:StickyWild = new StickyWild(originalSymbol.symName, new PIXI.Point(i, j));
                    stickyWild.position.x = Helper.getSymbolPositions(i, j)[0];
                    stickyWild.position.y = Helper.getSymbolPositions(i, j)[1];
                    this._overlayWilds.push(stickyWild);
                    stickyWild.alpha = 0;
                    this.addChildAt(stickyWild, 0);
                }
            }
        }

        this.shuffleWilds(this._overlayWilds);

        for(let k:number = 0; k < this._overlayWilds.length; k++) {
            let tempStickyWild:StickyWild = this._overlayWilds[k];
            this._allOverlayWilds.push(tempStickyWild);
            this._addNewWildsTL.add(this.createLightningToStickyWildTL(Helper.getSymbolPositions(tempStickyWild.originalReelPosition.x, tempStickyWild.originalReelPosition.y)));
            this._addNewWildsTL.add(() => tempStickyWild.alpha = 1, "-=0.3");
        }
        this._overlayWilds = [];
        this._addNewWildsTL.add(() => this._newWildsAdded = false);

        return this._addNewWildsTL;
    }

    private shuffleWilds(stickyWilds:StickyWild[]) {
        for(let i = stickyWilds.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [stickyWilds[i], stickyWilds[j]] = [stickyWilds[j], stickyWilds[i]];
        }
    }

    /**
     * Show Wild and put original symbol back on reel behind Wild before spin starts.
     */
    public showAllWilds():void {
        let tempWild:StickyWild;
        for(let i:number = 0; i < this._allOverlayWilds.length; i++) {
            tempWild = this._allOverlayWilds[i];
            tempWild.visible = true;
            Reels.getSymbol(tempWild.originalReelPosition.x, tempWild.originalReelPosition.y)!.replaceWith(tempWild.originalSymbolName, tempWild.originalReelPosition.x);
        }
    }

    public removeAllStickyWilds():void {
        let tempWild:StickyWild;
        while(this._allOverlayWilds.length > 0) {
            tempWild = this._allOverlayWilds.pop()!;
            this.removeChild(tempWild);
        }
    }

    public disableOverlayWilds():TimelineLite {
        if(this._removeTL && this._removeTL.isActive()) {
            this._removeTL.pause();
            this._removeTL.kill();
        }
        this._removeTL = new TimelineLite();
        const removeTLarray:TimelineLite[] = [];
        for(let i:number = 0; i < this._allOverlayWilds.length; i++) {
            let removeTL:TimelineLite = new TimelineLite();
            removeTL.add(() => this._allOverlayWilds[i].originalSymbolName = Reels.getSymbol(this._allOverlayWilds[i].originalReelPosition.x, this._allOverlayWilds[i].originalReelPosition.y)!.symName);
            removeTL.add(() => Reels.getSymbol(this._allOverlayWilds[i].originalReelPosition.x, this._allOverlayWilds[i].originalReelPosition.y)!.replaceWith("W", this._allOverlayWilds[i].originalReelPosition.x));
            removeTL.add(this._allOverlayWilds[i].getRemoveChainsTL());
            removeTLarray.push(removeTL);
        }
        for(let i:number = 0; i < ThorGameModuleConfig.thorReelWildsView.allOverlayWilds.length; i++) {
            let removeTL:TimelineLite = new TimelineLite();
            removeTL.add(() => ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].originalSymbolName = Reels.getSymbol(ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].originalReelPosition.x, ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].originalReelPosition.y)!.symName);
            removeTL.add(() => Reels.getSymbol(ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].originalReelPosition.x, ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].originalReelPosition.y)!.replaceWith("W", ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].originalReelPosition.x));
            removeTL.add(ThorGameModuleConfig.thorReelWildsView.allOverlayWilds[i].getRemoveChainsTL());
            removeTLarray.push(removeTL);
        }
        this._removeTL.add(removeTLarray);
        this._removeTL.add(() => this.removeAllStickyWilds());
        this._removeTL.add(() => ThorGameModuleConfig.thorReelWildsView.removeAllStickyWilds());
        return this._removeTL;
    }

    public abortDisableOverlayWilds():void {
        if(this._removeTL && this._removeTL.isActive()) {
            this._removeTL.pause();
            this._removeTL.kill();
        }
        let tempWild:StickyWild;
        while(this._allOverlayWilds.length > 0) {
            tempWild = this._allOverlayWilds.pop()!;
            tempWild.originalSymbolName = Reels.getSymbol(tempWild.originalReelPosition.x, tempWild.originalReelPosition.y)!.symName;
            Reels.getSymbol(tempWild.originalReelPosition.x, tempWild.originalReelPosition.y)!.replaceWith("W", tempWild.originalReelPosition.x);
            this.removeChild(tempWild);
        }
    }
}